import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';

import NavBarLogo from '@assets/chrome/navbar-logo.svg';
import ContactCenterTitle from '@assets/contact-center-title.svg';
import paths from '@app/routes/paths';
import useAuth from '@modules/AuthModule/hooks/useAuth';
import { BodyText, Icon, Popover, Stack } from '@servicetitan/design-system';
import UserStatusMenuWithFurthestTask from '@modules/UserStatusModule/components/UserStatusMenu/UserStatusMenuWithFurthestTask/UserStatusMenuWithFurthestTask';

import styles from './NavBar.module.css';
import UserMenu from './components/UserMenu/UserMenu';
import { permissionSets, RequirePermissions } from '@app/permissions';
import { layoutLocators } from '@locators/layout';
import useCallState from '@modules/SoftPhoneModule/useCallState';
import { useState } from 'react';
import SoftPhoneModule from '@modules/SoftPhoneModule';
import OutboundCallModal from './components/OutboundCallModal/OutboundCallModal';

const NavBar = () => {
  const callState = useCallState();
  const { serviceName } = useAuth();
  const [showCallState, setShowCallState] = useState(false);
  const [showOutboundCallModal, setShowOutboundCallModal] = useState(false);
  const { pathname } = useLocation();

  const isSettings = pathname.startsWith(`/settings`);

  const handleNavLogoClick = () => {
    // if (environment.MODE === 'development') {
    setShowCallState(!showCallState);
    // }
  };

  return (
    <Stack
      className={classNames('bg-neutral-300', styles.navBarContainer)}
      justifyContent='space-between'
    >
      <Stack>
        <Popover
          direction='bl'
          width='s'
          popoverContentClassName='p-1-i'
          open={showCallState}
          trigger={
            <Stack
              onClick={handleNavLogoClick}
              className={classNames('bg-white', styles.logoContainer)}
              justifyContent='center'
              alignItems='center'
            >
              <NavBarLogo />
            </Stack>
          }
        >
          <div>
            <pre>{JSON.stringify(callState, undefined, 2)}</pre>
            <button onClick={() => SoftPhoneModule.callControl.disconnect()}>
              Disconnect
            </button>
          </div>
        </Popover>

        <Link to={paths.home} className='d-f m-l-1 align-items-center'>
          <ContactCenterTitle />
        </Link>
      </Stack>
      <Stack justifyContent='center' alignItems='center' spacing={3}>
        <BodyText className={classNames('c-neutral-70', 'ta-center')}>
          {serviceName}
        </BodyText>

        <button
          aria-label='Make an outbound call'
          className={classNames(
            styles.icon,
            showOutboundCallModal && styles.activeIcon,
          )}
          onClick={() => setShowOutboundCallModal(!showOutboundCallModal)}
        >
          <Icon name='phone_outbound' size={24} />
        </button>
        <RequirePermissions
          permissions={permissionSets.admin.ALL}
          permissionsMatch='any'
        >
          <Link
            id={layoutLocators.navBar.settingsBtn}
            className={classNames(styles.icon, isSettings && styles.activeIcon)}
            to={paths.settings}
          >
            <Icon name='settings' size={24} />
          </Link>
        </RequirePermissions>

        <UserStatusMenuWithFurthestTask />
        <UserMenu />
      </Stack>
      <OutboundCallModal
        open={showOutboundCallModal}
        setOpen={setShowOutboundCallModal}
      />
    </Stack>
  );
};

export default NavBar;
